import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FcCalendar } from "react-icons/fc";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import { getLastEmission } from "@store/action/planning/EmissionAction";

const FilterBlog = ({ t }) => {
  const store = useSelector((state) => state.emissions).Last;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getLastEmission());
  }, []);
  const lang = localStorage.getItem("lang") || "en";
  const lang1 = lang.substring(1, lang.length - 1) || "en";

  const renderRecentPostTopics = () => {
    if (store?.length) {
      return store?.map((item, i) => {
        return (
          <div className="blog-filter" key={i}>
            <ul className="blog-suggest">
              <li>
                <div className="suggest-img">
                  <Link to={`/emission/${item.id}`}>
                    <img
                      width="70px"
                      height="60px"
                      src={item.picture}
                      alt="topic"
                    />
                  </Link>
                </div>
                <div className="suggest-content">
                  <div className="suggest-title">
                    <div className="mail-body">
                      <div className="mail-message">
                        <h4
                          style={{ width: "200px" }}
                          className="text-truncate"
                        >
                          {item?.name}
                        </h4>
                      </div>
                    </div>
                  </div>

                  <div className="suggest-meta mx-1">
                    <div className="suggest-date">
                      <FcCalendar />
                      <p>
                        {new Date(item.created_at).toLocaleString(
                          `${lang1}-US`,
                          {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          }
                        )}
                      </p>
                    </div>
                    <div className="suggest-comment">
                      <i className="fa fa-comments"></i>
                      <p>{item.nbr_comments}</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        );
      });
    }
  };

  return (
    <div className="col-lg-3">
      <div className="row">
        <div className="col-lg-12">
          <form className="blog-src">
            <input type="text" placeholder={t("Search...")} />
            <button>
              <i className="fa fa-search"></i>
            </button>
          </form>
        </div>
        <div className="col-md-7 col-lg-12">
          <div className="blog-filter">
            <h3>{t("Recent post")}</h3>
            {renderRecentPostTopics()}
          </div>
        </div>

        <div className="col-md-6 col-lg-12">
          <div className="blog-filter">
            <h3>{t("follow us")}</h3>
            <ul className="blog-icon">
              <li>
                <FacebookShareButton url="https://facebook.com">
                  <FacebookIcon size={30} round={true} />
                </FacebookShareButton>
              </li>

              <li>
                <TwitterShareButton url="https://twitter.com/">
                  <TwitterIcon size={30} round={true} />
                </TwitterShareButton>
              </li>
              <li>
                <WhatsappShareButton url="https://web.whatsapp.com/">
                  <WhatsappIcon size={30} round={true} />
                </WhatsappShareButton>
              </li>
              <li>
                <FacebookMessengerShareButton url="https://facebook.com">
                  <FacebookMessengerIcon size={30} round={true} />
                </FacebookMessengerShareButton>
              </li>
              <li>
                <EmailShareButton>
                  <EmailIcon size={30} round={true} />
                </EmailShareButton>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBlog;
